import React from "react";

export const ErrorMessage = ({ message, children }) => (
  <div className="text-center m-3" style={{ color: "#555555" }}>
    <h4>{message}</h4>
    {children}
  </div>
);
